module.exports = __webpack_public_path__ + "img/facebook.16324500.svg";